/**
 * Created by yangxuanbin on 07/02/2018
 **/
import storage from '../../utils/localStore';
import cookie from 'react-cookies'

let initialAuthState = { isLoggedIn: false,redirectPath:false };
const usr = storage.getItem('usr');
// const usr = cookie.load('user');
if(usr && usr!="" && usr.token!=""){
    initialAuthState={
        isLoggedIn:true,
        redirectPath:false,
        ...usr
    }
}


export default function adminInfo(state=initialAuthState, action){
  switch (action.type){
    case "LOGIN":
      return{
        ...state,
        ...action.data,
        isLoggedIn: true,
      };
    case "LOGINOUT":
      storage.removeItem('usr');
      cookie.remove('userInfo');
      return{isLoggedIn:false,};
    default:
      return state;

  }
}


// WEBPACK FOOTER //
// ./src/reduxModule/reducers/userInfo.js